import React from 'react';
import ReactDOM from 'react-dom';
import './MainBody.css'
import './Skills.css'

import C from './Images/C.png'
import Java from './Images/java.png'
import Python  from './Images/python.jpg'
import Assembly from './Images/assembly.png'
import ReactN from './Images/react.png'
import Php from './Images/php.png'
import Asp from './Images/asp.png'
import Jquery  from './Images/jquery.png'
import Html  from './Images/html.jpg'
import Css  from './Images/css.png'
import Js  from './Images/js.png'
import Clips  from './Images/clips.png'
import Ocaml  from './Images/ocaml.jpeg'
import Prolog  from './Images/prolog.png'
import Git  from './Images/git.png'
import Android  from './Images/android.png'
import Mysql  from './Images/mysql.png'
import Arabic  from './Images/arabic.png'
import English  from './Images/english.png'




class Skills extends React.Component {
  render (){
    return (
      <div id="skills" class="container-fluid text-center bg-grey">
        <h2>SKILLS</h2>
        <br/>
        <h3>Languages</h3><hr width="40%" class="new5" />
        <div class="row">
          <div class="col-sm-4">
            <img src={C} width="80px" height="80px"/>
            <h4>C Langauge</h4>
            <p></p>
          </div>
          <div class="col-sm-4">
            <img src={Java} width="80px" height="80px"/>
            <h4>Java</h4>
            <p></p>
          </div>
          <div class="col-sm-4">
            <img src={Assembly} width="80px" height="80px"/>
            <h4>Assembly (MIPS)</h4>
          </div>
        </div>


        <div class="row topmar">
          <div class="col-sm-4">
            <img src={ReactN} width="80px" height="80px"/>
            <h4>React js </h4>
          </div>
          <div class="col-sm-4">
            <img src={Php} width="80px" height="80px"/>
            <h4>php</h4>
          </div>
          <div class="col-sm-4">
            <img src={Asp} width="80px" height="80px"/>
            <h4>Asp.net</h4>
          </div>
        </div>


        <div class="row  topmar ">
          <div class="col-sm-4">
            <img src={Html} width="80px" height="80px"/>
            <h4>HTML</h4>
          </div>
          <div class="col-sm-4">
            <img src={Css} width="80px" height="80px"/>
            <h4>Css</h4>
          </div>
          <div class="col-sm-4">
            <img src={Js} width="80px" height="80px"/>
            <h4>javaScript</h4>
          </div>
        </div>


        <div class="row topmar">
          <div class="col-sm-4">
            <img src={Jquery} width="80px" height="80px"/>
            <h4>jQuery</h4>
          </div>
          <div class="col-sm-4">
            <img src={Ocaml} width="80px" height="80px"/>
            <h4>O'caml</h4>
          </div>
          <div class="col-sm-4">
            <img src={Clips} width="80px" height="80px"/>
            <h4>Clips</h4>
          </div>
        </div>


        <div class="row topmar">
          <div class="col-sm-4">
            <img src={Prolog} width="80px" height="80px"/>
            <h4>prolog</h4>
          </div>
        </div>

        <h3>Platform</h3><hr width="40%" class="new5" />
        <div class="row topmar">
          <div class="col-sm-4">
            <img src={Git} width="80px" height="80px"/>
            <h4>github</h4>
          </div>
          <div class="col-sm-4">
            <img src={Android} width="80px" height="80px"/>
            <h4>Android Studio</h4>
          </div>
          <div class="col-sm-4">
            <img src={Mysql} width="80px" height="80px"/>
            <h4>MySQL</h4>
          </div>

        </div>

        <h3 class="toptop">Soft Skills</h3><hr width="40%" class="new5" />

        <div class="container  toptop text-center">
          <div class="col-6 col-sm-3 broderr bodySc">Fast learner and able to grasp different concepts quickly.</div>
          <div class="col-6 col-sm-3 broderr bodySc">Team worker and eager to be part of a team that handles a project and gives a proper presentation.</div>
          <div class="col-6 col-sm-3 broderr bodySc">Ability to work under pressure and match deadlines for projects.</div>
          <div class="col-6 col-sm-3 broderr bodySc">Experienced programmer able to comprehend and debug already existing codes.</div>
        </div>

        <h3 class="toptop">Languages</h3><hr width="40%" class="new5" />
        <div class="row topmar">
          <div class="col-sm-6">
            <img src={English} width="80px" height="80px"/>
            <h4>Fluent English</h4>

          </div>
          <div class="col-sm-6">
            <img src={Arabic} width="80px" height="80px"/>
            <h4>Native Arabic</h4>

          </div>
        </div>

      </div>
    )
  }
}
export default Skills;

// <span class="glyphicon glyphicon-heart logo-small"></span>
// <span class="glyphicon glyphicon-lock logo-small"></span>

// <span class="glyphicon glyphicon-wrench logo-small "></span>
// <span class="glyphicon glyphicon-certificate logo-small"></span>
// <span class="glyphicon glyphicon-leaf logo-small"></span>
